import { Method } from 'axios';
import { apiCall } from '@/utility/api/apiUtils';
import {
  API_DELETE_PHASE,
  API_METHOD_DELETE,
} from '@/constants/apiConstants';
import { generateHash } from '@/utility/auth/generateHashValue';

export interface DeletePhasePayload {
  type: 'phase' | 'section' | 'item';
  uuid: string;
}

export interface DeletePhaseResponse {
  status: 'SUCCESS' | 'ERROR';
  message?: string;
}

export const deletePhaseFromAPI = async (
  phaseUuid: string,
  payload: DeletePhasePayload,
): Promise<DeletePhaseResponse> => {
  const method: Method = API_METHOD_DELETE;
  const url = API_DELETE_PHASE(phaseUuid);
  const jsonString = JSON.stringify(payload);
  const additionalHeaders = {
    hash: generateHash(jsonString),
  };

  try {
    const response = await apiCall({
      method,
      url,
      data: payload,
      headers: additionalHeaders,
    });
    return response;
  } catch (error) {
    console.error('Error deleting phase entity:', error);
    throw error;
  }
};
